import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { HttpRequest, HttpClient, HttpEventType, HttpEvent } from '@angular/common/http';
import { SpinnerService } from '@services/spinner.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import { DxFileUploaderComponent } from 'devextreme-angular/ui/file-uploader';

@Component({
    selector: 'cz-uploadPopup',
    templateUrl: './uploadPopup.component.html',
    styleUrls: ['./uploadPopup.component.css'],
    standalone: false
})
export class DocUploadPopupComponent {

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOkClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() popupVisible: boolean;
  @Input() uploadContext: any;
  uploadFiles: File[];

  @ViewChild('form', { static: false }) form: DxFormComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: DxFileUploaderComponent;

  allowedFileExtensions: string[] = ['.rtf', '.txt', '.docx', '.jpg', '.jpeg', '.pdf', '.xlsx', '.msg'];
  uploadFileName: string = '';
  toUpload: number = 0;
  isUploaded: number = 0;
  isUploadCanceled: boolean = false;
  uploadWaitPopupVisible: boolean = false;

  constructor(private spinnerService: SpinnerService, private ajaxService: AjaxService, private http: HttpClient) {
    this.onClickUebernehmen = this.onClickUebernehmen.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
  }

  get canUpload(): boolean {
    return (!this.uploadFiles || !this.uploadFiles.length) || (this.validation(false) === false);
  }

  addFile(event: any) {
    this.uploadFiles = event.value;
  }

  onUploadCancel(e: any) {
    this.isUploadCanceled = true;
  }

  onClickUebernehmen() {

    let isValid = true;
    const errorMsgs: string[] = [];

    for (let index = 0; index < this.uploadFiles.length; index++) {
      const file = this.uploadFiles[index];
      const ext = file.name.split('.').pop();
      if (!this.allowedFileExtensions.find(x => x.endsWith(ext))) {
        errorMsgs.push('Dateitype wird nicht akzeptiert! \'' + file.name + '\'');
        isValid = false;
      }

    }
    if (!isValid) {
      notify({
        contentTemplate: () => {
          let html = '';
          for (let index = 0; index < errorMsgs.length; index++) {
            const errorMsg = errorMsgs[index];
            html += errorMsg + '<br>';
          }

          return $('<div class="dx-toast-message" role="alert"></div>').html(html);
        },
        width: 600
      }, 'error', 3000);
      return;
    }

    if (this.validation()) {
      this.isUploaded = 0;
      this.toUpload = this.uploadFiles.length;
      this.popupVisible = false;
      this.uploadWaitPopupVisible = true;

      const _obj = {
        ownerId: this.uploadContext.ownerId,
        entityArt: this.uploadContext.entityArt,
        bezeichnung: this.uploadContext.bezeichnung,
        docHash: this.uploadContext.docHash
      };

      this._upload(_obj, this.uploadFiles);
    }
  }

  private _upload(context: any, files: File[]) {
    if (this.isUploaded === this.toUpload || this.isUploadCanceled === true) {
      this.uploadWaitPopupVisible = false;
      this.isUploaded = 0;
      this.toUpload = 0;
      this.uploadFiles = [];
      this.uploadFileName = '';
      this.onOkClose.emit(true);
      return;
    }

    const file = files[this.isUploaded];
    this.uploadFileName = file.name;

    const lastDate = new Date(file.lastModified);
    lastDate.setHours(lastDate.getHours() + 1);
    context.lastModifiedDate = lastDate;

    const input = new FormData();
    input.append(file.name, file);
    input.append('context', JSON.stringify(context));

    const _headers = this.ajaxService.getRequestHeaders({ contentType: false });
    const uploadReq = new HttpRequest('POST', 'api/Dokument/AddFiles', input, {
      reportProgress: true,
      headers: _headers.headers
    });

    this.http.request(uploadReq).subscribe({
      next: (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.Response) {
          this.isUploaded++;
          this._upload(context, files);
        }
      },
      error: (err: any) => {
        this.stopLoading();
        throw err;
      }
    });
  }

  onClickClose() {
    // this.onClose.emit(null);
    this.popupVisible = false;
  }

  validation(withMsg: boolean = true) {
    const validationResult = this.form.instance.validate();

    if (!validationResult.isValid) {
      if (withMsg) {
        let msg = '';
        for (const err of validationResult.brokenRules) {
          msg += err.message + '\r\n';
        }

        notify({
          message: msg,
          width: 600
        }, 'error', 3000);
      }

      return false;
    }
    else {
      return true;
    }
  }

  onShowingPopup(event: any) {
    this.uploadFiles = null;
  }

  onHiddenPopup(event: any) {
    this.fileUploader.instance.reset();
    this.uploadFileName = '';
    this.uploadFiles = null;
    this.uploadContext = null;
    this.onClose.emit(null);
  }

  private startLoading() {
    this.spinnerService.show();
  }

  private stopLoading() {
    this.spinnerService.hide();
  }
}
